import { mostHighlightedTextApi } from '@/entities/article';
import { PATH } from '@/shared/constants';
import type {
  CardBackgroundColorType,
  HighlightedStatementCard,
} from '@/shared/types';

const cardColors: CardBackgroundColorType[] = [
  'primary',
  'purple',
  'skyblue',
  'primary',
];

export const getMostHighlightedTexts = async () => {
  const { data } = await mostHighlightedTextApi();

  const mostHighlightedTexts: HighlightedStatementCard[] = data.map(
    ({ text, news }, index) => ({
      highlightedStatement: text,
      title: news.title,
      link: `${PATH.DETAIL}/${news.id}`,
      color: cardColors[index % cardColors.length],
    })
  );

  return mostHighlightedTexts;
};
